import Vue from "vue";
import Router from "vue-router";
import About from "./views/About.vue";
import Support from "./views/Support.vue";
import Privacy from "./views/Privacy.vue";
import Press from "./views/Press.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: About
    },
    {
      path: "/support",
      name: "support",
      component: Support
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Privacy
    },
    {
      path: "/press",
      name: "press",
      component: Press
    },
    { path: "*", redirect: "/" }
  ]
});
